var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "form",
                {
                  attrs: {
                    action: _vm.action,
                    method: "POST",
                    enctype: "multipart/form-data"
                  }
                },
                [
                  _c("input", {
                    attrs: { type: "hidden", name: "_token" },
                    domProps: { value: _vm.token }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-inline" }, [
                    _c("label", { attrs: { for: "importacion" } }, [
                      _vm._v("Importación")
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.subidaClickada,
                            expression: "!subidaClickada"
                          }
                        ],
                        staticClass: "btn-success",
                        attrs: { type: "submit" },
                        on: { click: _vm.clickSubir }
                      },
                      [_c("i", { staticClass: "fa fa-upload" })]
                    ),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipoFechaComprobante,
                            expression: "form.tipoFechaComprobante"
                          }
                        ],
                        attrs: { type: "radio", id: "todasFechas", value: "T" },
                        domProps: {
                          checked: _vm._q(_vm.form.tipoFechaComprobante, "T")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "tipoFechaComprobante",
                              "T"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Todas las fechas")])
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipoFechaComprobante,
                            expression: "form.tipoFechaComprobante"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "tipoFechaComprobante",
                          value: "E"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.tipoFechaComprobante, "E")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "tipoFechaComprobante",
                              "E"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Fecha de emisión")])
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipoFechaComprobante,
                            expression: "form.tipoFechaComprobante"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          id: "tipoFechaComprobanteA",
                          value: "A"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.tipoFechaComprobante, "A")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "tipoFechaComprobante",
                              "A"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Fecha de autorización")])
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "comprobantes",
        attrs: {
          tipoFecha: "A",
          params: _vm.form,
          buscarNumero: "",
          createButton: false,
          editButton: false,
          columns: [
            {
              display: "Tipo de comprobante",
              value: "descripcion_tipo_comprobante"
            },
            {
              display: "Nombre/Razón social",
              value: "razon_social"
            },
            {
              display: "Nombre comercial",
              value: "nombre_comercial"
            },
            {
              display: "Ruc",
              value: "ruc"
            },
            {
              display: "Dirección",
              value: "direccion_matriz"
            },
            {
              display: "Fecha de emisión",
              value: "fecha_emision"
            },
            {
              display: "Total sin imp.",
              value: "total_sin_impuestos"
            },
            {
              display: "Total",
              value: "total"
            }
          ],
          fechas: "",
          buttons: [
            {
              icon: "fa-edit",
              class: "btn-info",
              event: "verComprobante",
              text: ""
            },
            {
              icon: "fa-download",
              class: "btn-success",
              event: "descargarComprobante",
              text: ""
            },
            {
              icon: "fa-eye",
              class: "btn-secondary",
              event: "verRide",
              text: ""
            }
          ],
          path: _vm.path,
          filterStatus: false,
          deleteButton: false
        },
        on: {
          verRide: _vm.verRide,
          verComprobante: _vm.verComprobante,
          descargarComprobante: _vm.descargarComprobante
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Comprobantes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-field" }, [
      _c("input", {
        attrs: { type: "file", name: "importacion", id: "importacion" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtrar por:")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc14d5a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc14d5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/MyBillBot.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4dc14d5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/MyBillBot.vue
// module chunks = 0